import { useContext } from 'react';
import { DesignSelectedElementContext } from '../DesignSelectedElementContext';

export default function useDesignSelectedElement() {
    return useContext(DesignSelectedElementContext);
}
